import * as React from 'react';
import './ProductSFMStandAlone.scss';
import ProductShipFromModal from '../ProductShipFromModal';
import { IPart } from 'src/components/PartDetails/PartDetailsDesktop/PartDetailsDesktop';
import Loader from '../Loader';
import productServiceInstance from 'src/services/products/ProductService';
import {
  getSupplierQuantity,
  formatAddress,
  getPickUpInfo,
  getShipFromInfo,
  linkLocationsToWarehouses
} from 'src/utils/partsBusinessLogic';
import i18n from 'src/translation/i18n';
import locationServiceInstance from 'src/services/location/LocationService';

/**
 * ProductShipFromModal stand alone
 * Gets all the data it needs from a part to show options
 */

export interface IProductSFMStandAloneProps {
  partNumber: string;
  mfc?: string;
  show: boolean;
  isPickUp: boolean;
  deliveryLocationCode: string;
  selectedAddresses: object;
  onClose: () => void;
  onChange: (address: object) => void;
  isDelivery: boolean;
  state: string;
  selectedQty: number;
}

export interface IProductSFMStandAloneState {
  defaultWarehouse: any;
  part: IPart;
  noPickUpList: any[];
  pickUpList: any[];
}

export class ProductSFMStandAlone extends React.Component<
  IProductSFMStandAloneProps,
  IProductSFMStandAloneState
> {
  public state: IProductSFMStandAloneState = {
    defaultWarehouse: null,
    part: null,
    noPickUpList: [],
    pickUpList: []
  };

  public componentDidMount() {
    this.getPartDetails();
  }

  private getWareshouseLocationsForPickUpOrDelivery = async (
    locations: any[],
    pickUpList: any[],
    isDelivery: boolean
  ) => {
    const index = isDelivery
      ? 0
      : locations.findIndex(p => this.props.deliveryLocationCode === p.code);
    const addresses = await locationServiceInstance.getLocations(
      locations[index].postalCode,
      isDelivery ? true : false,
      isDelivery ? null : this.props.deliveryLocationCode
    );

    return linkLocationsToWarehouses(pickUpList, addresses);
  };

  private getPartDetails = () => {
    console.log('modal', this.props);
    productServiceInstance
      .getProductDetails(this.props.partNumber, this.props.mfc)
      .then(async res => {
        const pickUp = getPickUpInfo(res.warehouses);
        const {
          shipFrom,
          defaultWarehouse,
          noPickUpList,
          pickUpList
        } = getShipFromInfo(res.warehouses, res.locations);
        const part: IPart = {
          images: res.images,
          modelsFound: res.modelsNumberTotalFound,
          name: res.name,
          notes:res.notes,
          productNumber: res.productNumber,
          description: res.description,
          price: res.partnerPrice,
          msrp: res.retailPrice,
          inStock: res.inStock,
          supplierQuantity: getSupplierQuantity(res.warehouses),
          state: res.state,
          extraProducts: res.extraProducts,
          extraTotalAmount: res.extraTotalAmount,
          pickUpFrom: pickUp.location,
          pickUpTo: pickUp.location,
          shipFrom,
          shipToName: res.address ? res.address.name : '',
          shipToAddress: formatAddress(res.address),
          replacedPart: res.replacedPart,
          replacedMfc: res.replacedMfc,
          stateDescription: res.stateDescription,
          specialOrder: res.specialOrder,
          isDropShip: res.isDropShip,
          discountInfo: res.discountInfo,
          orderDetailStatus: res.orderDetailStatus,
          deliveryFrom: pickUp.location,
          deliveryTo: pickUp.location,
          alternateParts: res.alternateProductsList,
          longDesc: res.longDesc,
          subPartNumber: res.subPartNumber,
          weight: res.weight,
          length: res.length,
          width: res.width,
          height: res.height	
        };
        this.setState({
          defaultWarehouse,
          part,
          noPickUpList,
          pickUpList:
            this.props.isPickUp || this.props.isDelivery
              ? await this.getWareshouseLocationsForPickUpOrDelivery(
                  res.locations,
                  pickUpList,
                  this.props.isDelivery
                )
              : pickUpList
        });
      })
      .catch(err => console.log(err));
  };

  public render() {
    if (this.state.defaultWarehouse == null || this.state.part == null) {
      return <Loader />;
    }

    return (
      <ProductShipFromModal
        show={this.props.show}
        onClose={this.props.onClose}
        type={this.props.isPickUp ? 'pick-up' : 'shipping'}
        defaultWarehouse={this.state.defaultWarehouse}
        supplierQuantity={
          this.state.part ? this.state.part.supplierQuantity : 0
        }
        deliverAddressesList={this.state.pickUpList}
        deliveryLocationCode={this.props.deliveryLocationCode}
        buttonVerbiage={i18n.t('common.changeStore')}
        handleChangeShipFrom={this.props.onChange}
        selectedAddresses={this.props.selectedAddresses}
        selectedPartState = {this.props.state}
        selectedPartQty = {this.props.selectedQty}

      />
    );
  }
}
